export default __webpack_public_path__ + "static/media/face1.59467388.svg";